import overview from './overview.md?raw';
import products from './domains/products.md?raw';
import charges from './domains/charges.md?raw';
import packaging from './domains/packaging.md?raw';
import compliance from './domains/compliance.md?raw';
import whyAi from './ai/why_ai.md?raw';
import skills from './ai/skills.md?raw';
import memory from './ai/memory.md?raw';
import dialog from './ai/dialog.md?raw';
import management from './management.md?raw';

export const contentMap = {
    'overview': overview,
    'products': products,
    'charges': charges,
    'packaging': packaging,
    'compliance': compliance,
    'why-ai': whyAi,
    'skills': skills,
    'memory': memory,
    'dialog': dialog,
    'management': management
};

export const handbookStructure = [
    {
        title: 'Überblick',
        slug: 'overview',
        icon: '🏠'
    },
    {
        title: 'Fachliche Domänen',
        items: [
            { title: 'Produkte & Modelle', slug: 'products', icon: '📦' },
            { title: 'Charges & Produktion', slug: 'charges', icon: '🏭' },
            { title: 'Verpackung & Logistik', slug: 'packaging', icon: '🚚' },
            { title: 'Compliance & Zertifikate', slug: 'compliance', icon: '⚖️' }
        ]
    },
    {
        title: 'KI im PIM',
        items: [
            { title: 'Warum KI?', slug: 'why-ai', icon: '🤖' },
            { title: 'Skills erklärt', slug: 'skills', icon: '🧩' },
            { title: 'Gedächtnis & Kontext', slug: 'memory', icon: '🧠' },
            { title: 'Dialog & Rückfragen', slug: 'dialog', icon: '💬' }
        ]
    },
    {
        title: 'Für Management',
        slug: 'management',
        icon: '💼'
    }
];
